import {
  Card,
  LoadingSkeleton,
} from "@twinkltech/curriculum-architect-component-library";

export const SkeletonCard = () => (
  <LoadingSkeleton>
    <Card>
      <Card.Label>
        <p>Loading</p>
      </Card.Label>
    </Card>
  </LoadingSkeleton>
);
